import React, { useState } from 'react';
import { Box, HStack, Pressable, VStack, View } from 'native-base';
import { FilterModal } from './FiltersModal';
import { SortByModal } from './SortByModal';
import { StoreModal } from './StoreModal';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';
import { SpIcon } from '~/shared/Icon';
import { faShoppingCart, faStore } from '@fortawesome/free-solid-svg-icons';
import { useAppNavigate } from '~/pages';
import { useDutchieStore, useI18n } from '@springbig/shared';
import { SearchBar } from '~/pages/shop/components/SearchBar';

export const ShopHeader = () => {

    const { icon, pressable_text, section_background } = useShopStyles();
    const [showFilters, setShowFilters] = useState(false);
    const [showSortBy, setShowSortBy] = useState(false);
    const [showStore, setShowStore] = useState(false);
    const { navigate, params } = useAppNavigate();
    const {
        filters,
        setFilters,
        sortByProp,
        retailer,
        fullfillmentOption,
        setShowStoreBottomSheet,
        isBusy,
        cartItemsAmount
    } = useDutchieStore();
    const { t } = useI18n();

    return (
        <>
            <VStack p={2} space={1} alignItems={'center'}>
                <HStack space={2} alignItems={'center'}>
                    <Pressable
                        bg={section_background}
                        py={1}
                        px={2}
                        borderRadius={4}
                        opacity={isBusy ? .7 : 1}
                        isDisabled={isBusy}
                        onPress={() => {

                            setShowFilters(true);
                        }}
                    >
                        <Caption color={pressable_text}>
                            { t('shop.filters') }
                        </Caption>
                    </Pressable>
                    <Pressable
                        bg={section_background}
                        py={1}
                        px={2}
                        borderRadius={4}
                        opacity={isBusy ? .7 : 1}
                        isDisabled={isBusy}
                        onPress={() => {

                            setShowSortBy(true);
                        }}
                    >
                        <HStack alignItems={'center'}>
                            <Caption>{ t('shop.sort') } </Caption>
                            <Caption color={pressable_text}>{ sortByProp?.label }</Caption>
                        </HStack>
                    </Pressable>
                </HStack>
                <HStack space={2} alignItems={'center'}>
                    <Pressable
                        bg={section_background}
                        py={1}
                        px={2}
                        borderRadius={4}
                        opacity={isBusy ? .7 : 1}
                        isDisabled={isBusy}
                        onPress={() => {

                            setShowStore(true);
                        }}
                    >
                        <HStack alignItems={'center'}>
                            <Caption color={pressable_text}>{ fullfillmentOption?.label }</Caption>
                            <Caption> { t('shop.in') } </Caption>
                            <Caption color={pressable_text}>{ retailer?.name }</Caption>
                        </HStack>
                    </Pressable>
                    <Pressable
                        rounded={20}
                        p={2}
                        bg={section_background}
                        opacity={isBusy ? .7 : 1}
                        isDisabled={isBusy}
                        onPress={() => {

                            setShowStoreBottomSheet(true);
                        }}
                    >
                        <SpIcon color={icon} icon={faStore}/>
                    </Pressable>
                    <Pressable
                        rounded={20}
                        p={2}
                        bg={section_background}
                        opacity={isBusy ? .7 : 1}
                        isDisabled={isBusy}
                        onPress={() => {

                            navigate(`w/${params.wallet_id}/shop/cart`);
                        }}
                    >
                        <View style={{ position: 'relative', display: 'inline-block' }}>
                            <SpIcon color={icon} icon={faShoppingCart} />
                            {cartItemsAmount && cartItemsAmount > 0 ? (
                                <Box
                                    style={{
                                        position: 'absolute',
                                        backgroundColor: 'red',
                                        color: 'white',
                                        borderRadius: '50%',
                                        fontSize: '12px',
                                        top: '-10px',
                                        right: '-20px',
                                        width: '20px',
                                        textAlign: 'center'
                                    }}
                                >
                                    <Caption color="white" fontSize="12px">
                                        {cartItemsAmount}
                                    </Caption>
                                </Box>
                            ) : <></>}
                        </View>
                    </Pressable>
                </HStack>
                <SearchBar backgroundColor={section_background} />
            </VStack>
            { showFilters &&
                <FilterModal
                    showFilters={showFilters}
                    filters={filters}
                    setFilters={setFilters}
                    setShowFilters={() => {

                        setShowFilters(!showFilters);
                    }}
                />
            }
            { showSortBy &&
                <SortByModal
                    showSortBy={showSortBy}
                    setShowSortBy={() => {

                        setShowSortBy(!showSortBy);
                    }}
                />
            }
            { showStore &&
                <StoreModal
                    showStore={showStore}
                    setShowStore={() => {

                        setShowStore(!showStore);
                    }}
                />
            }
        </>
    );
};
